
/* Scent Society Australia - B2B Quick add fix */

(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.product-quick-add--button');
    const quickAdd = button?.closest('product-quick-add');

    if (
      !quickAdd ||
      quickAdd.dataset.ssaB2b !== 'true' ||
      quickAdd.dataset.form === 'true'
    ) return;

    const minimum = Math.max(
      1, parseInt(quickAdd.dataset.minQuantity, 10) || 1
    );

    const increment = Math.max(
      1, parseInt(quickAdd.dataset.quantityIncrement, 10) || 1
    );

    // Let Beyond handle ordinary one-at-a-time products.
    if (minimum === 1 && increment === 1) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (quickAdd.dataset.ssaLoading === 'true') return;

    quickAdd.dataset.ssaLoading = 'true';
    quickAdd.setAttribute('aria-busy', 'true');

    try {
      const Cart = customElements.get('cart-element');

      if (!Cart) {
        throw new Error('Cart not ready. Please try again.');
      }

      // Check how many of this variant are already in the cart.
      const response = await fetch(`${Shopify.routes.cart}.js`);

      if (!response.ok) {
        throw new Error('Could not check your cart.');
      }

      const cart = await response.json();
      Cart.fillBasket(cart.items);

      const variantId = String(quickAdd.dataset.id);

      const alreadyInCart = cart.items.reduce((total, item) => {
        return total + (
          String(item.variant_id) === variantId
            ? item.quantity
            : 0
        );
      }, 0);

      // First click meets the minimum; later clicks use the increment.
      const toAdd = alreadyInCart < minimum
        ? minimum - alreadyInCart
        : increment;

      const maximum = parseInt(quickAdd.dataset.maxQuantity, 10);

      if (
        Number.isFinite(maximum) &&
        alreadyInCart + toAdd > maximum
      ) {
        throw new Error(
          `This product has a maximum quantity of ${maximum}.`
        );
      }

      // Use Beyond's existing cart functionality.
      await Cart.addItems({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: toAdd
          }],
          sections: Cart.sections
        })
      }, button);

      await Cart.fetchBasket();

      Cart.updateTotals(
        Object.values(Cart.basket).reduce(
          (total, count) => total + count, 0
        )
      );

    } catch (error) {
      console.error('SSA B2B Quick add:', error);
      alert(error.message || 'Unable to add product.');
    } finally {
      delete quickAdd.dataset.ssaLoading;
      quickAdd.setAttribute('aria-busy', 'false');
    }
  }, true);
})();
